import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewRef} from '@angular/core';
import {Account} from '../../model/account/account';
import {LoaderStateService} from '../../loader.service';
import {AccountService} from '../../data-access-layer/account/account.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../auth/auth.service';
import {UserStateService} from '../../auth/user-state-service';
import {DatapointsPageStateService} from '../../dataset/datapoints/datapoints-page-state.service';
import {environment, isEnabled} from '../../../environments/environment';
import {Functionalities} from '../../../environments/app-functionalities';
import {Constants} from '../../constants';
import { ImagePaths } from './image-paths';

@Component({
    selector: 'map-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnInit {

    accounts: Account[] = [];
    loading = false;

    overlayComponentEnabled = isEnabled(Functionalities.OVERLAYS);
    thematicMapFeatureEnabled = isEnabled(Functionalities.THEMATICMAP);

    logo = Constants.LOGO;

    appUrls = {
        collexter: 'https://app.collexter.com/data-collection/1',
        kainobi: 'https://app.kainobi.com',
        policybase: 'https://app.policybase.co',
        schemaytic: 'https://app.schematyc.com/login',
    };

    private subscription;

    iconMapping: { [key in keyof typeof ImagePaths]: string } = {
        collexter: ImagePaths.collexter,
        kainobi: ImagePaths.kainobi,
        policybase: ImagePaths.policybase,
        schemaytic: ImagePaths.schemaytic,
      };
    constructor(
        private readonly loader: LoaderStateService,
        private readonly accountService: AccountService,
        private readonly cdRef: ChangeDetectorRef,
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        readonly datapointsPageStateService: DatapointsPageStateService,
        private readonly authService: AuthService,
        readonly userStateService: UserStateService) {
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    }

    ngOnInit(): void {
        this.subscription = this.loader.state.subscribe((value) => {
            this.loading = value;
            if (this.cdRef && !(this.cdRef as ViewRef).destroyed) {
                this.cdRef.detectChanges();
            }
        }, (err) => {
            console.log(err);
        });

        this.userStateService.userStateSubject.subscribe(state => {
           this.accounts = this.userStateService.availableAccounts;
        });
    }


    navigateToDatapoints(account: Account): void {
        let datasets = this.userStateService.availableDatasetsInAccount(account.id);
        if (datasets && datasets.length) {
            this.router.navigate([`private/account/${account.id}/dataset/${datasets[0].id}/datapoints/map`]);
        }
    }

    /**
     * JIRA-EMFDU-001 T-20: whether to show the Settings gear against this account. Delegates to
     * AuthService.canUpload - superadmin, account admin, or the EMFD+U permission bit - which is
     * synchronous, unlike UserStateService.hasWriteAccess whose backing map is filled by an async
     * initialize(). authService is private here, so the template goes through this method.
     */
    canOpenSettings(accountId: number): boolean {
        return this.authService.canUpload(accountId);
    }

    navigateToSettings(account: Account): void {
        // Administrators keep landing on Fields. An EMFD+U user has only Groups in their
        // sub-navigation and the Fields route now rejects them, so send them straight to Groups.
        const landingPage = this.authService.can("update", account.id) ? "fields" : "groups";
        this.router.navigate([`private/account/${account.id}/settings/${landingPage}`]);
    }

    logout(): void {
        this.authService.logout();
    }

    support() {
        var link=document.createElement('a');
        link.target = "_blank";
        const token = localStorage.getItem("access_token") || "invalid";
        link.href = environment.wpLogin + token;
        link.click();
        }

    supportCenter() {
        this.router.navigate(["/public/support-center"]);
    }    

        openUrl(url: string): void {
            window.open(url, '_blank');
        }
        navigateToAPIMeter(){
            this.router.navigate(["private/overlays/api-meter"]);
        }

}
